<template>
  <div>
    <b-breadcrumb :items="breadCrumbs" />

    <div class="row" v-if="BRAND != 'EB'">
      <div class="col-6 offset-3">
        <b-form @submit.prevent="search">
          <b-input-group class="mb-3" prepend="Find Orders">
            <b-form-input v-model="searchTerm" />
            <b-input-group-append>
              <b-btn text="Button" type="submit" variant="success">Find</b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </div>
    </div>

    <b-row v-if="orders && orders.length">
      <b-col md="6" class="my-1">
        <b-form-group horizontal label="Filter" class="mb-0">
          <b-input-group>
            <b-form-input
              v-model="filter"
              placeholder="Type to Search"
              :autofocus="true"
              @blur="trimExpiryDate"
              @change="trimExpiryDate"
              @input="trimExpiryDate"
            />
            <b-input-group-append>
              <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="6" class="my-1 orders_buttons">
        <div class="float-right" v-if="orders.length > 0">
          Total orders: {{ orders.length }}
        </div>
        <div class="float-right">
          <b-button
            size="sm"
            variant="success"
            class="ml-2"
            @click="resync"
            v-if="BRAND === 'EB'"
            >ReSync</b-button
          >
        </div>
        <!-- <b-form-group horizontal label="Per page" class="mb-0">
					<b-form-select :options="pageOptions" v-model="perPage" />
        </b-form-group>-->
      </b-col>
    </b-row>

    <b-row class="mt-3" v-if="orders && orders.length">
      <b-col md="12">
        <b-table
          :items="orders"
          :fields="fields"
          :current-page="currentPage"
          :per-page="perPage"
          :filter="filter"
          v-if="orders"
        >
          <template slot="cell(order_id)" slot-scope="row">
            {{ row.item.order_id }}
            <span v-if="row.item.payment_code === 'blockchain'">
              <br />
              <img
                style="width: 32px;height: 32px;"
                src="/assets/icons/blockchain.png"
              />
            </span>
            <b-badge
              class="text-center"
              variant="warning"
              v-if="!row.item.complete"
              >Partially Picked</b-badge
            >
          </template>
          <template slot="cell(name)" slot-scope="row">
            {{ row.item.firstname + " " + row.item.lastname }}
          </template>
          <template slot="cell(shipping)" slot-scope="row">
            <div style="width:200px;">
              <span :class="rowClass(row.item.shipping_method)">
                {{ row.item.shipping_method }}
              </span>
            </div>
          </template>
          <template slot="cell(items)" slot-scope="row">
            <ul>
              <li :key="index" v-for="(item, index) in row.item.items">
                {{
                  item.quantity + " X " + item.model + " (" + item.name + ")"
                }}
              </li>
            </ul>
          </template>
          <template slot="cell(actions)" slot-scope="row">
            <div style="width:200px;">
              <b-button
                size="sm"
                variant="primary"
                class="ml-2"
                :to="'/order/' + row.item.order_id"
                v-if="BRAND != 'EB'"
                >View</b-button
              >

              <b-button
                size="sm"
                variant="warning"
                class="ml-2"
                :to="'/order/' + row.item.order_id + '/pick'"
                :disabled="pickingDisabled(row.item)"
                >Pick</b-button
              >
              <b-button
                size="sm"
                variant="danger"
                class="ml-2"
                @click="deleteOrder(row.item.order_id)"
                v-if="BRAND === 'EB'"
                >Delete</b-button
              >
            </div>
          </template>
        </b-table>
      </b-col>
    </b-row>
    <b-row v-if="orders && orders.length">
      <b-col md="6" class="my-1">
        <b-pagination
          :total-rows="orders.length"
          :per-page="perPage"
          v-model="currentPage"
          class="my-0"
        />
      </b-col>
    </b-row>

    <b-row v-if="!orders || orders.length == 0">
      <b-col md="6" class="my-1 offset-md-3">
        <b-alert show variant="success">No Orders to pick. Yay!</b-alert>
        <b-button
          size="sm"
          variant="success"
          class="ml-2"
          @click="resync"
          v-if="BRAND === 'EB'"
          >ReSync</b-button
        >
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "opencart-orders",
  components: {},
  data() {
    return {
      orders: null,
      searchTerm: "",
      fields: [
        { key: "order_id", label: "#", sortable: true },
        { key: "date_added", label: "Date" },
        { key: "name", label: "Name" },
        { key: "items", label: "Items" },
        { key: "shipping", label: "Shipping", class: "text-center" },
        {
          key: "brand",
          label: "Brand",
          class: "text-center",
          tdClass: this.BRAND !== "EB" ? "d-none" : "",
          thClass: this.BRAND !== "EB" ? "d-none" : ""
        },
        { key: "actions", label: "" }
      ],
      breadCrumbs: [
        { text: "Dashboard", to: { name: "dashboard" } },
        { text: "Orders", active: true }
      ],
      currentPage: 1,
      perPage: 50,
      pageOptions: [10, 25, 50],
      filter: null
    };
  },
  mounted: function() {
    this.listOrders();
  },
  methods: {
    resync() {
      let loader = this.$loading.show();
      this.$http.get(this.APIURL + this.BRAND + "/order-resync").then(
        () => {
          location.reload();
        },
        error => {
          loader.hide();
          console.log(error);
        }
      );
    },
    deleteOrder(orderID) {
      let loader = this.$loading.show();
      this.$http.delete(this.APIURL + this.BRAND + "/order/" + orderID).then(
        () => {
          location.reload();
        },
        error => {
          loader.hide();
          console.log(error);
        }
      );
    },
    trimExpiryDate() {
      const filter = this.filter;
      var matches = filter.match(/-[0-9]{6}/);
      if (matches) {
        this.filter = filter.split(matches[0])[0];
      }
    },
    pickingDisabled(order) {
      if (!order.brand && this.BRAND == "EB") {
        return true;
      }
      return false;
    },
    listOrders: function() {
      let loader = this.$loading.show();
      this.$http.get(this.APIURL + this.BRAND + "/order").then(
        response => {
          this.orders = response.data;
          loader.hide();
        },
        error => {
          loader.hide();
          console.log(error);
        }
      );
    },
    rowClass: function(shippingMethod) {
      if (this.BRAND == "IM") {
        return shippingMethod.toLowerCase().includes("ups")
          ? "bg-danger text-white shipping-red"
          : "";
      } else {
        return shippingMethod.toLowerCase().includes("express")
          ? "bg-danger text-white shipping-red"
          : "";
      }
    },
    search() {
      //search for order and if found redirect to order
      let loader = this.$loading.show();
      this.$http
        .get(this.APIURL + this.BRAND + "/order/" + this.searchTerm.trim())
        .then(
          () => {
            let orderId = this.searchTerm;
            this.searchTerm = "";
            loader.hide();
            this.$router.push({ name: "order", params: { id: orderId } });
          },
          () => {
            loader.hide();
            this.searchTerm = "";
            this.$swal(
              "Not Found",
              "Not Orders with this ID were found!!!",
              "warning"
            );
          }
        );
    }
  }
};
</script>
<style lang="scss" scoped>
.orders_buttons {
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  text-align: end;
}
</style>
